import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ColorConstants } from '../../ui-helpers/constants/color-constants';

@Injectable({
  providedIn: 'root',
})
export class ServersideAlertService {
  private alertStyleSubject = new BehaviorSubject<'success' | 'warn' | 'error'>(
    'error'
  );
  private alertMessagesSubject = new BehaviorSubject<string[]>([]);
  private alertReportedSubject = new BehaviorSubject<boolean>(false);
  private colorSubject = new BehaviorSubject<string>('');
  private backgroundColorSubject = new BehaviorSubject<string>('');

  alertStyle$: Observable<'success' | 'warn' | 'error'> =
    this.alertStyleSubject.asObservable();
  alertMessages$: Observable<string[]> =
    this.alertMessagesSubject.asObservable();
  alertReported$: Observable<boolean> =
    this.alertReportedSubject.asObservable();
  color$: Observable<string> = this.colorSubject.asObservable();
  backgroundColor$: Observable<string> =
    this.backgroundColorSubject.asObservable();

  reportAlert(
    alertMessages: string[],
    alertStyle: 'success' | 'warn' | 'error'
  ) {
    this.alertStyleSubject.next(alertStyle);
    this.alertMessagesSubject.next(alertMessages);
    this.alertReportedSubject.next(true);
    this.colorSubject.next(this.setColor(alertStyle));
    this.backgroundColorSubject.next(this.setBackgroundColor(alertStyle));
  }

  dereport() {
    this.alertReportedSubject.next(false);
  }

  private setColor(alertStyle: 'success' | 'warn' | 'error'): string {
    switch (alertStyle) {
      case 'success':
        return ColorConstants.NowGreenPrimary;
      case 'warn':
        return ColorConstants.NowOrange;
      case 'error':
        return ColorConstants.KendoThemeRed;
      default:
        return ColorConstants.KendoThemeRed;
    }
  }

  private setBackgroundColor(alertStyle: 'success' | 'warn' | 'error'): string {
    let color;
    let opacity;
    switch (alertStyle) {
      case 'success':
        color = ColorConstants.NowGreenSecondary;
        opacity = 70;
        break;
      case 'warn':
        color = ColorConstants.NowOrange;
        opacity = 10;
        break;
      case 'error':
        color = ColorConstants.KendoThemeRed;
        opacity = 10;
        break;
      default:
        color = ColorConstants.KendoThemeRed;
        opacity = 10;
    }
    return `rgba(${ServersideAlertService.hexToRgb(color)}, ${(
      opacity / 100
    ).toString()})`;
  }

  private static hexToRgb(hex: string) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? `${parseInt(result[1], 16).toString()}, ${parseInt(
          result[2],
          16
        ).toString()}, ${parseInt(result[3], 16).toString()}`
      : null;
  }
}
